import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("ACCOUNT_TRANSACTIONS"),
	...createNetworkActions("ACCOUNT_TRANSACTION"),
	...createAction("PERIOD_CHANGED"),
};
